import { Button, Form, InputGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { faCalendar, faSave } from "@fortawesome/free-solid-svg-icons";
import StringToInputDate from "../../../util/StringToInputDate";
import StringToDate from "../../../util/StringToDate";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import ErrorAdd from "../../../util/ErrorAdd";

function WidgetItemDeadlines({ idObject, idWidget, number, idItem, editMode, added, onlyRead }) {

    /*
   idObject:
   ID	Name
   1	Задача
   2	Регулярная задача
   3	Доска
   4	Проект
   5	Пользователь
   6   Регулярная задача. Трекер
   */

    const dispatch = useDispatch()

    const [log, setLog] = useState(null);
    const [loading, setLoading] = useState(null);
    const [dateStart, setDateStart] = useState(null);
    const [dateComplete, setDateComplete] = useState(null);
    const [edit, setEdit] = useState(false);

    const stateTaskList = useSelector((state) => state.taskList);
    const stateTaskRlist = useSelector((state) => state.taskRlist);
    const stateBoardTasklist = useSelector((state) => state.boardTaskList);

    useEffect(() => {
        if (idObject === 1) {
            if (stateTaskList.list.filter(a => a.ID === idItem).length > 0) {
                setDateStart(stateTaskList.list.filter(a => a.ID === idItem)[0].Date_Start);
                setDateComplete(stateTaskList.list.filter(a => a.ID === idItem)[0].Date_End);
            }
        }
        else if (idObject === 2) {
            if (stateTaskRlist.list.filter(a => a.ID === idItem).length > 0) {
                setDateStart(stateTaskRlist.list.filter(a => a.ID === idItem)[0].Date_Start);
                setDateComplete(stateTaskRlist.list.filter(a => a.ID === idItem)[0].Date_End);
            }
        }
        else if (idObject === 3) {
            if (stateBoardTasklist.list.filter(a => a.ID === idItem).length > 0) {
                setDateStart(stateBoardTasklist.list.filter(a => a.ID === idItem)[0].Date_Start);
                setDateComplete(stateBoardTasklist.list.filter(a => a.ID === idItem)[0].Date_End);
            }
        }

    }, [idItem, stateTaskList.list, stateTaskRlist.list, stateBoardTasklist.list]);

    useEffect(() => {
        if (added !== null & added !== undefined) {
            //Ограничение на добавление виджета определенного номера. Иначе открываются сразу все виджеты
            if (added.idWidget === idWidget & added.number === number) {
                setEdit(true);
            }
        }
    }, [added]);

    function DateGet() {
        if (dateStart !== null & dateComplete !== null) {
            return (<div className="task_card_calendar" onClick={() => onlyRead === false && setEdit(true)}><FontAwesomeIcon icon={faCalendar} /> {StringToDate(dateStart)}г - {StringToDate(dateComplete)}г</div>)
        }
        else if (dateStart !== null & dateComplete === null) {
            return (<div className="task_card_calendar" onClick={() => onlyRead === false && setEdit(true)}><FontAwesomeIcon icon={faCalendar} /> Начало  {StringToDate(dateStart)}г</div>)
        }
        else if (dateStart === null & dateComplete !== null) {
            return (<div className="task_card_calendar" onClick={() => onlyRead === false && setEdit(true)}><FontAwesomeIcon icon={faCalendar} /> Завершение  {StringToDate(dateComplete)}г</div>)
        }
        else if (dateStart === null & dateComplete === null) {
            return (<div className="task_card_calendar" onClick={() => setEdit(true)}><FontAwesomeIcon icon={faCalendar} /> Не заполнено</div>)
        }
    }

    function updateHandler() {

        if (idObject === 1) {
            axios.post('/api_tracker/task/updateDate', { ID_Task: idItem, Date_Start: dateStart, Date_End: dateComplete })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setLoading(false);
                    }
                    else {
                        setLog(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
        if (idObject === 3) {
            axios.post('/api_tracker/board/taskUpdateDate', { ID: idItem, Date_Start: dateStart, Date_End: dateComplete })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setLoading(false);
                    }
                    else {
                        setLog(res.data.Error);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
    }

    return (
        edit === true ? (
            <>
                <InputGroup >
                    <Form.Control type="date" defaultValue={StringToInputDate(dateStart)} onChange={(e) => { setDateStart(e.target.value === '' ? null : e.target.value) }} />
                    <Form.Control type="date" defaultValue={StringToInputDate(dateComplete)} onChange={(e) => { setDateComplete(e.target.value === '' ? null : e.target.value) }} />
                    <Button variant="outline-success" onClick={() => { setEdit(false); updateHandler(); }}>
                        <FontAwesomeIcon icon={faSave} />
                    </Button>
                </InputGroup>
            </>
        )
            :
            (
                <div><DateGet /></div>
            )
    )
}

export default WidgetItemDeadlines;